// extracted by mini-css-extract-plugin
export default {"collageContainer":"G564094 G56d6b0","collageItem":"G81292c","collageImage":"Gd0a409","emptyItem":"G9f3224"};